export function TextLogicRenderer({ visualSpec }: { visualSpec: Record<string, unknown> }) {
  const statements = (Array.isArray(visualSpec.statements) ? visualSpec.statements : []) as string[];
  return (
    <div className="w-full rounded-lg border border-white/10 bg-slate-950/35 p-4">
      {statements.map((statement) => (
        <p key={statement} className="text-base leading-7 text-slate-200">
          {statement}
        </p>
      ))}
    </div>
  );
}
